import {contactApiHostName} from "../../../endpoint";
import {defaultHeaders} from "../../../headers";

export const getMembers = async (groupId) => {
  try {
    const result = await fetch(
      `${contactApiHostName}/group-members/${groupId}`,
      {
        method: "GET",
        headers: {
          ...defaultHeaders,
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        },
      }
    );
    return {
      hasSuccess: result.status === 200,
      data: await result.json(),
    };
  } catch (err) {
    return {
      hasSuccess: false,
      data: err.message,
    };
  }
};
